/**
 * @generated SignedSource<<b2d8cad2a984e699dcde58afd541ba09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type McpAuthorizeRoute_Query$variables = {};
export type McpAuthorizeRoute_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
  } | null;
};
export type McpAuthorizeRoute_Query = {
  variables: McpAuthorizeRoute_Query$variables;
  response: McpAuthorizeRoute_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "McpAuthorizeRoute_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "McpAuthorizeRoute_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "56bf459c234e399648befeadb3c6dc3a",
    "id": null,
    "metadata": {},
    "name": "McpAuthorizeRoute_Query",
    "operationKind": "query",
    "text": "query McpAuthorizeRoute_Query {\n  viewer {\n    actualPersonId\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e317ae3ed396ef15d831352e83d89fdf";

export default node;
